module.exports =  function dateFormatter(date) {
    const formattedDate = date
        .split(' ')
        .reduce((str, part, i) => str + (i === 2 ? ',' : '') + part)
        .split(',')
        .map((chunk, index) => (index === 1 ? chunk.replace(/(\d+)(st|nd|rd|th)/g, '$1') : chunk))
        .join(', ') + ` ${new Date().getFullYear()}`;
    return formattedDate;
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/utility/date-stringformatter.js
 **/